import { Box } from '@mui/material';
import React from 'react';
import type { IDashboardTabPanelProps } from '../interfaces';

export const DashboardTabPanel = ({ id, labelledBy, children }: IDashboardTabPanelProps) => {
  return (
    <Box
      role="tabpanel"
      id={id}
      aria-labelledby={labelledBy}
      sx={{ width: '100%', minWidth: 0 }}
    >
      {children}
    </Box>
  );
};
